import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HeaderLogo.css";

function HeaderLogo() {
  const [isScrolling, setIsScrolling] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      setIsScrolling(true);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 3000);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const handleLogoClick = () => {
    navigate("/");
    // Scroll to top of page
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <span
      className={`header-logo${isScrolling ? " header-logo-scrolling" : ""}`}
      onClick={handleLogoClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleLogoClick();
        }
      }}
    >
      <b>C</b>D<b>M</b>
    </span>
  );
}

export default HeaderLogo;
